import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ClockFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="clockFilled" ref={ref} {...props}>
      <path d="M12,2.25A9.75,9.75,0,1,0,21.75,12,9.76,9.76,0,0,0,12,2.25Zm4.65,14.49a1,1,0,0,1-1.41,0l-3.88-3.89a1,1,0,0,1-.3-.7V7a1,1,0,0,1,2,0v4.76l3.59,3.59A1,1,0,0,1,16.65,16.74Z" />
    </Icon>
  ),
) as IconWithRender;

ClockFilledIcon.displayName = 'ClockFilledIcon';
ClockFilledIcon.renderIcon = (props) => <ClockFilledIcon {...props} />;
export default ClockFilledIcon;
